/**
 * Какое хозяйство подставить в форму сохранения поля.
 *
 * Правило появилось на живом прогоне первого клиента: у нового тенанта
 * `sessionFarmId` пуст (его запоминают с прошлого сохранения, а сохранений ещё
 * не было), и селектор оставался пустым даже когда хозяйство ровно одно —
 * человек упирался в «выберите хозяйство», имея единственный вариант.
 *
 * Порядок намеренный:
 *  1. уже выбранное в форме — не перебиваем ничей ручной выбор;
 *  2. запомненное с прошлого сохранения — самый частый случай на живом тенанте;
 *  3. единственное хозяйство — выбор безальтернативный, делаем его сами.
 *
 * Когда хозяйств несколько и ничего не запомнено — возвращаем пустую строку:
 * угадывать за человека, в какое из них класть поле, нельзя.
 */
export function preselectFarmId(
  current: string,
  sessionFarmId: string | null | undefined,
  farms: readonly { id: string }[],
): string {
  if (current) return current;
  if (sessionFarmId) return sessionFarmId;
  return farms.length === 1 ? farms[0].id : '';
}
